import React, { useMemo } from "react";
import { EmptyStateErro } from "../../components/EmptyState";
import PainelTabela from "../../components/PainelTabela";
import { PageLoader } from "../../components/LoadingMarcenaria";
import { useDados } from "../../context/DadosContext";
import { fmtDiasEmFila } from "../../utils/calculos";
import { isNo } from "../../utils/data";
import { F } from "../../utils/gerencialFields";
import { buildDeadlineStatus, compareDatesAsc } from "../../utils/status";

const COLUNAS = [
  { key: "cliente", label: "Cliente", noWrap: true },
  { key: "ambiente", label: "Ambiente" },
  { key: "entregaContrato", label: "Entrega Prevista", labelCurto: "entrega", tipo: "data", width: "110px" },
  { key: "limiteMedicao", label: "Limite Medição", labelCurto: "limite", tipo: "data", width: "110px" },
  // Bloco TBL.5: gate RBAC preco:view
  { key: "valor", label: "Valor", labelCurto: "valor", tipo: "moeda", width: "110px", requerPermissao: "preco:view" },
  { key: "diasEmFila", label: "Dias em fila", labelCurto: "fila", width: "90px" },
  { key: "status", label: "Status", width: "100px" },
];

export default function FilaMedicao() {
  const { dados, erro, initialLoading } = useDados();

  // Memoizado (e antes dos early-returns — Rules of Hooks): sem isso, cada
  // re-render recriava `linhas` (filter+map+sort de 400+ itens) e a nova
  // referência invalidava toda a cadeia de memos do PainelTabela.
  const linhas = useMemo(
    () =>
      dados
        .filter((row) => {
          const naoFutura = isNo(row[F.OBRA_FUTURA]);
          const temLiberacao = Boolean(row[F.LIBERACAO_DA_OBRA]);
          const semMedicao = !row[F.MEDICAO_REALIZADO];

          return naoFutura && temLiberacao && semMedicao;
        })
        .map((row) => {
          const limiteMedicao = row[F.MEDICAO_LIMITE];

          return {
            cliente: row[F.NOME_DO_CLIENTE],
            rowPlanilha: row,
            ambiente: row[F.AMBIENTE],
            entregaContrato: row[F.ENTREGA_PREVISTA],
            limiteMedicao,
            valor: row[F.VALOR_DO_AMBIENTE],
            // entrou na fila de medicao quando a obra foi liberada
            diasEmFila: fmtDiasEmFila(row[F.LIBERACAO_DA_OBRA]),
            ...buildDeadlineStatus(limiteMedicao),
          };
        })
        .sort((left, right) => compareDatesAsc(left.limiteMedicao, right.limiteMedicao)),
    [dados],
  );

  const totalizadores = useMemo(
    () => [
      { label: "Total de Ambientes", valor: linhas.length },
      {
        label: "Em Atraso",
        valor: linhas.filter((linha) => linha.statusVariant === "danger").length,
      },
    ],
    [linhas],
  );

  if (initialLoading) {
    return <PageLoader scope="medicao" />;
  }

  if (erro) {
    return <EmptyStateErro erro={erro} />;
  }

  return (
    <PainelTabela
      titulo="Fila de Medição"
      exportPainelId="medicao"
      colunas={COLUNAS}
      linhas={linhas}
      totalizadores={totalizadores}
      densidade="compact"
      mostrarPaginacao={false}
      persistirNoBackend
    />
  );
}
